import { Injectable } from '@angular/core';
import { Permissions } from './permission.interface';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { UserInfo } from 'src/app/shared/interfaces/usern-info';
import { BehaviorSubject } from 'rxjs';
import { MenuPermissionService } from './menu-permission.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  public loginToken: string;
  public userProfileData: UserInfo;
  items: MenuItem[] = [];
  user_permissions: Permissions;
  // only for internal writable state
  private readonly _activeMenu = new BehaviorSubject<string>('');
  is_customer: any=0;
  lead_id: any='';
  customer_id: any='';
  // exposing as hot (multicast) observable for cosumtion
  // public readonly activeMenu = this._activeMenu.asObservable();

  constructor(
    private router:Router,
    private activatedRoute: ActivatedRoute,
    private menuPermissionService: MenuPermissionService
  ) {
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        /* Your code goes here on every router change */
        let dataObj = { item: { routerLink: [ev.url] } };
        this.menuChange(dataObj);
      }
    });
  }
  // set & get token
  public settoken(token: string) {
    localStorage.setItem('access_token', token);
    this.loginToken = token;
  }

  public gettoken() {
    return this.loginToken;
  }

  // set & get user profile data
  public setuserProfileData(data: UserInfo) {
    this.userProfileData = data;
    this.is_customer = data.is_customer;
    this.lead_id = data.lead_id;
    this.customer_id = data.customer_id;
    //localStorage.setItem('userProfileData', JSON.stringify(data));
  }
  public setleadId(data: any) {
    this.lead_id = data.lead_id;
  }
  public setcustomerId(data: any) {
    this.customer_id = data.customer_id;
  }
  public getuserProfileData() {
    return this.userProfileData;
    //return JSON.parse(localStorage.getItem('userProfileData') || '{}');
  }
public setisCustomer(data: any) {
  console.log(data,'data');
  this.is_customer = data.is_customer;
}

  public clearUserProfileData() {
    this.userProfileData = null;
    this.is_customer = null;
    this.lead_id = null;
    this.customer_id = null;
    this.user_permissions = null;
    this.items = [];
    this._activeMenu.next('');
  }

  public get currentMenu() {
    return this._activeMenu.asObservable();
  }

  getUserName() {
    return this.userProfileData.username;
  }

  setPermissions() {
    if (
      localStorage.getItem('user_permissions') != 'undefined' &&
      localStorage.getItem('user_permissions') != 'null'
    ) {
      this.user_permissions = JSON.parse(
        localStorage.getItem('user_permissions') || '{}'
      );
    }
  }

  get timezone() {
    return this.userProfileData?.timezone?.name;
  }

  setMenus(){
    this.setPermissions();

    // Check if user is customer and set static menu
    if ( this.is_customer === 1 ||this.userProfileData?.is_customer === 1) {
      this.items = [
        {
          label: 'Dashboard',
          icon: 'pi acv-dashboard',
          expanded: this.checkActiveState('/customer-dashboard/map'),
          styleClass: 'single',
          routerLink: ['/customer-dashboard/map'],
          routerLinkActiveOptions: { exact: false },
          command: (e:any) => this.menuChange(e),
        },
        {
          label: 'Questionnaire',
          icon: 'pi pi-file-edit',
          expanded: this.checkActiveState('/settings/templates'),
          styleClass: 'single',
          routerLink: ['/settings/templates/list'],
          routerLinkActiveOptions: { exact: true },
          queryParams: { type: 'questionnaire' },
          command: (e:any) => this.menuChange(e),
        },
        {
          label: 'Contracts',
          icon: 'pi pi-fw ic-report',
          expanded: this.checkActiveState('/settings/templates'),
          styleClass: 'single',
          routerLink: ['/settings/templates/list'],
          routerLinkActiveOptions: { exact: true },
          queryParams: { type: 'contract' },
          command: (e:any) => this.menuChange(e),
        },
        {
          label: 'Settings',
          icon: 'pi pi-fw ic-setting',
          expanded: this.checkActiveState('/settings'),
          styleClass: 'has-childs',
          routerLink: ['/settings/roles/list'],
          routerLinkActiveOptions: { exact: false },
          items: [
            { label: 'Roles', icon: 'ic-role', routerLink: ['/settings/roles/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e), },
            { label: 'Users', icon: 'ic-person', routerLink: ['/settings/users/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e), },
          ]
        }
      ];
    } else {
      // Regular menu for other users
      this.items = [
        {
          label: 'Manage Trips',
          icon: 'pi pi-fw ic-import',
          expanded: this.checkActiveState('/manage-trips'),
          styleClass: 'has-childs',
          routerLink: ['/manage-trips/trip-requests/list'],
          command: (e:any) => this.menuChange(e),
          routerLinkActiveOptions: { exact: false },
          items: [
            { label: 'Calendar', icon: 'ic-calednar', routerLink: ['/manage-trips/calendar/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e), },
            { label: 'Trip Requests', icon: 'ic-head-phones', routerLink: ['/manage-trips/trip-requests/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e), },
            { label: 'Trip Rejects', icon: 'ic-cancel-circle', routerLink: ['/manage-trips/trip-rejects/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e), },
            { label: 'Leg Prioritization', icon: 'ic-pin-location', routerLink: ['/manage-trips/leg-prioritization/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e), },
          ]
        },
        {
          label: 'Settings',
          icon: 'pi pi-fw ic-setting',
          expanded: this.checkActiveState('/setting'),
          styleClass: 'has-childs',
          routerLink: ['/settings/users'],
          routerLinkActiveOptions: { exact: false },
          items: [
            { label: 'Users', icon: 'ic-person', routerLink: ['/settings/users/list'], routerLinkActiveOptions: { exact: true }, command: (e:any)  => this.menuChange(e),  },
            { label: 'Roles', icon: 'ic-role', routerLink: ['/settings/roles/list'], routerLinkActiveOptions: { exact: false }, command: (e:any)  => this.menuChange(e), },
            { label: 'Trucks', icon: 'ic-truck', routerLink: ['/settings/trucks/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e), },
            { label: 'Trailers', icon: 'ic-trailers', routerLink: ['/settings/trailers/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e), },
            { label: 'Drivers', icon: 'ic-drivers', routerLink: ['/settings/drivers/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e), },
            { label: 'Locations', icon: 'ic-location', routerLink: ['/settings/locations/list'], routerLinkActiveOptions: { exact: true }, command: (e:any)  => this.menuChange(e), },
            { label: 'Exceptions', icon: 'pi pi-exclamation-circle', routerLink: ['/settings/exceptions/list'], routerLinkActiveOptions: { exact: true }, command: (e:any)  => this.menuChange(e), },
            { label: 'Templates', icon: 'pi pi-fw ic-report', routerLink: ['/settings/templates/list'], routerLinkActiveOptions: { exact: true }, command: (e:any)  => this.menuChange(e), },
          ]
        },
        {
          label: 'Setup',
          icon: 'pi pi-fw ic-setting-gear',
          expanded: this.checkActiveState('/setup'),
          styleClass: 'has-childs',
          routerLink: ['/setup/services'],
          routerLinkActiveOptions: { exact: false },
          items: [
            { label: 'Services', icon: 'ic-head-phones', styleClass: this.isLinkActive('/setup/services/') ? 'p-menuitem-link-active' : '', routerLink: ['/setup/services/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e) },
            { label: 'Legs', icon: 'ic-pin-location', routerLink: ['/setup/legs/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e) },
            { label: 'Milestones', icon: 'ic-milestone', routerLink: ['/setup/milestones/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e) },
            { label: 'Actions', icon: 'ic-aim', routerLink: ['/setup/actions/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e) },
          ]
        },
         {
          label: 'Customers',
          icon: 'pi pi-fw ic-customer',
          expanded: this.checkActiveState('/customers'),
          styleClass: 'has-childs',
          routerLink: ['/customers/leads'],
          routerLinkActiveOptions: { exact: false },
          items: [
            { label: 'Leads', icon: 'icon-lead', styleClass: this.isLinkActive('/customers/leads/') ? 'p-menuitem-link-active' : '', routerLink: ['/customers/leads/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e) },
            { label: 'Active Customers', icon: 'icon-active-customer', routerLink: ['/settings/customers'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e) },
            { label: 'Inactive Customers', icon: 'icon-inactive-customer', routerLink: ['/customers/inactive-customers/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e) },
            { label: 'Rejected Leads', icon: 'icon-rejected-lead', routerLink: ['/customers/rejectedlead/list'], routerLinkActiveOptions: { exact: true }, command: (e:any) => this.menuChange(e) },
          ]
        },
        {
          label: 'Report',
          icon: 'pi pi-fw ic-report',
          expanded: this.checkActiveState('/reports'),
          styleClass: 'single',
          routerLink: ['/reports/detail'],
          routerLinkActiveOptions: { exact: true },
        },
        {
          label: 'Dispatcher Dashboard',
          icon: 'pi acv-dashboard',
          expanded: this.checkActiveState('dashboards/dispatcher-dashboard'),
          styleClass: 'single',
          routerLink: ['/dashboards/dispatcher-dashboard'],
          routerLinkActiveOptions: { exact: true },
          command: (e:any) => this.menuChange(e),
        },
        {
          label: 'LC Dashboard',
          icon: 'pi acv-dashboard',
          expanded: this.checkActiveState('dashboards/lc-dashboard'),
          styleClass: 'single',
          routerLink: ['/dashboards/lc-dashboard'],
          routerLinkActiveOptions: { exact: true },
          command: (e:any) => this.menuChange(e),
        },
      ];
    }

    // Test customer permissions (temporary debugging)
    if (this.is_customer === 1 || this.userProfileData?.is_customer === 1) {
      this.menuPermissionService.testCustomerPermissions();
    }

    // Test parent-submenu scenarios (temporary debugging)
    this.menuPermissionService.testParentSubmenuScenarios();

    // Use unified permission-based filtering
    this.items = this.menuPermissionService.filterMenuItems(this.items, this.user_permissions);

    // Set the best route for each menu item
    this.setBestRoutesForMenus();
  }


// filterMainMenus() {
//   // return items.filter((item) => {
//   //     const hasPermission = permissions[item.label]['view'];
//   //     return hasPermission;
//   //   });
//   // Skip permission checks, allow all menus
//   this.items = [...this.items];
// }

  checkActiveState(givenLink: any) {
    // Special handling for customer users
    // if (this.userProfileData?.is_customer === 1) {
    //   // For customer users, Questionnaire and Contract both use /settings/templates
    //   if (givenLink === '/settings/templates') {
    //     return this.router.url.includes('/settings/templates');
    //   }
    //   // For other routes, use the original logic
    //   return this.router.url.indexOf(givenLink) !== -1;
    // } else {
      // Original logic for non-customer users
      if (this.router.url.indexOf(givenLink) === -1) {
        return false;
      } else {
        return true;
      }
    // }
  }

  isLinkActive(link: string) {
    const url = this.router.url;
    //console.log(url);

    return link === url.substring(1, url.indexOf('?'));
  }

  menuChange(evnt: any) {
    if (evnt.item.routerLink) {
      this._activeMenu.next(evnt.item.routerLink[0])
      let route_arr = evnt.item.routerLink[0].split('/');
      let route_url = `/${route_arr[1]}/${route_arr[2]}`;

      this.items.forEach((menuItem) => {
        if (menuItem.items && menuItem.items?.length > 0) {
          //Checking if any match route exist in sub-menus
          let findMatchingRoute = menuItem.items.find((x) =>
            x.routerLink[0].includes(route_url)
          );

          if (findMatchingRoute) {
            menuItem.expanded = true;
          } else {
            menuItem.expanded = false;
          }
        }
      });

      this.checkActiveSubMenu(evnt.item.routerLink[0].split('/').splice(0,3).join("/"))
    }
  }

  checkActiveSubMenu(route:any = null){
    let menus = document.querySelectorAll(".p-panelmenu-root-submenu li a");

    menus.forEach((item:any) => {
      let match_path = route ? route : this.router.url.split('/').splice(0,3).join("/");

      if(item?.href.includes(match_path)){
        item.classList.add("p-menuitem-active");
      }
      else{
        item.classList.remove("p-menuitem-active");
      }
    });
  }

  setQueryParam(param:string, value: any){
    const queryParams: Params = { [param] : value };
    this.router.navigate(
      [],
      {
        relativeTo: this.activatedRoute,
        queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      }
    );
  }

  /**
   * Set the best accessible route for each menu item
   */
  private setBestRoutesForMenus(): void {
    this.items.forEach(menuItem => {
      if (menuItem.items && menuItem.items.length > 0) {
        // For "Manage Trips", preserve the routerLink to Trip Requests if already set
        if (menuItem.label === 'Manage Trips' && menuItem.routerLink && menuItem.routerLink[0] === '/manage-trips/trip-requests/list') {
          // Keep the existing routerLink to Trip Requests
          return;
        }
        // Find the first accessible sub-item
        const firstAccessibleRoute = this.menuPermissionService.getFirstAccessibleRoute(menuItem.items);
        if (firstAccessibleRoute) {
          menuItem.routerLink = [firstAccessibleRoute];
        }
      }
    });
  }

  /**
   * Check if user has permission for a specific route
   */
  public hasPermissionForRoute(route: string): boolean {
    return this.menuPermissionService.hasPermissionForRoute(route, this.user_permissions);
  }

  /**
   * Get the best route for a category based on permissions
   */
  public getBestRouteForCategory(categoryName: string): string | null {
    return this.menuPermissionService.getBestRouteForCategory(categoryName, this.user_permissions);
  }
}
